const API_KEY = "AIzaSyCemmU1nnBGncln8JsQBI-6sNbf0u6q4zg";

export default API_KEY;